/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetOwnClaimRequest } from './AssetOwnClaimRequest';
import {
    AssetOwnClaimRequestFromJSON,
    AssetOwnClaimRequestFromJSONTyped,
    AssetOwnClaimRequestToJSON,
    AssetOwnClaimRequestToJSONTyped,
} from './AssetOwnClaimRequest';

/**
 * 
 * @export
 * @interface SaveAssetOwnClaimsRequest
 */
export interface SaveAssetOwnClaimsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetOwnClaimsRequest
     */
    hasOwnClaims: boolean | null;
    /**
     * 
     * @type {Array<AssetOwnClaimRequest>}
     * @memberof SaveAssetOwnClaimsRequest
     */
    ownClaims: Array<AssetOwnClaimRequest>;
}

/**
 * Check if a given object implements the SaveAssetOwnClaimsRequest interface.
 */
export function instanceOfSaveAssetOwnClaimsRequest(value: object): value is SaveAssetOwnClaimsRequest {
    if (!('hasOwnClaims' in value) || value['hasOwnClaims'] === undefined) return false;
    if (!('ownClaims' in value) || value['ownClaims'] === undefined) return false;
    return true;
}

export function SaveAssetOwnClaimsRequestFromJSON(json: any): SaveAssetOwnClaimsRequest {
    return SaveAssetOwnClaimsRequestFromJSONTyped(json, false);
}

export function SaveAssetOwnClaimsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetOwnClaimsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hasOwnClaims': json['hasOwnClaims'],
        'ownClaims': ((json['ownClaims'] as Array<any>).map(AssetOwnClaimRequestFromJSON)),
    };
}

export function SaveAssetOwnClaimsRequestToJSON(json: any): SaveAssetOwnClaimsRequest {
    return SaveAssetOwnClaimsRequestToJSONTyped(json, false);
}

export function SaveAssetOwnClaimsRequestToJSONTyped(value?: SaveAssetOwnClaimsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasOwnClaims': value['hasOwnClaims'],
        'ownClaims': ((value['ownClaims'] as Array<any>).map(AssetOwnClaimRequestToJSON)),
    };
}

